import { useQueryClient } from '@tanstack/react-query';

/** Invalidates every query that renders punch-derived attendance data, so
 *  Add/Edit/Delete Punch and correction approve/revert/create all reflect
 *  instantly across the daily table, stat tiles, Punch Timeline modal,
 *  monthly grid, and corrections lists — not just the caller's own view.
 *
 *  Salary is punch-derived too: the backend reprices the month on every punch
 *  mutation, so the salary surfaces are invalidated here for the same reason the
 *  hour tiles are. Leaving them out would show fresh hours beside a stale figure. */
export function useInvalidateAttendance() {
  const queryClient = useQueryClient();
  return () => {
    void queryClient.invalidateQueries({ queryKey: ['attendance', 'daily'] });
    void queryClient.invalidateQueries({ queryKey: ['attendance', 'summary'] });
    void queryClient.invalidateQueries({ queryKey: ['attendance', 'punches'] });
    void queryClient.invalidateQueries({ queryKey: ['attendance', 'timeline'] });
    void queryClient.invalidateQueries({ queryKey: ['attendance', 'monthly-overview'] });
    void queryClient.invalidateQueries({ queryKey: ['attendance', 'corrections'] });
    void queryClient.invalidateQueries({ queryKey: ['my-attendance'] });
    void queryClient.invalidateQueries({ queryKey: ['my-punches'] });
    void queryClient.invalidateQueries({ queryKey: ['my-corrections'] });
    void queryClient.invalidateQueries({ queryKey: ['payroll', 'salary'] });
    void queryClient.invalidateQueries({ queryKey: ['dashboard'] });
  };
}
